// 导入全部主题css文件
const modules = import.meta.glob("@/theme/modules/*/*.ts");

export enum ThemeEnum {
  dark = "dark",
  light = "light",
}

// 默认海蓝，本地存储
/**
 * 根据color参数动态引入对应css文件
 * @param color 主题颜色
 * @throws {Error} 如果找不到对应的主题配置文件
 */
export const setTheme = async (color: ThemeEnum): Promise<void> => {
  // 获取匹配的主题文件
  const themeFile = Object.entries(modules).find(([key]) => key.includes(color));

  // 如果找不到对应的主题文件，则抛出错误
  if (!themeFile) {
    throw new Error("未找到对应主题配置文件");
  }
  // 加载匹配的主题文件
  try {
    await themeFile[1]();
    const htmlElement = document.documentElement;
    htmlElement.setAttribute("theme", color);

    // 设置页签顶部背景色
    // setTopBarBg(color);
  } catch (e) {
    console.error("加载主题文件时出错：", e);
    throw new Error("加载主题文件时出错");
  }
};

